module.exports = __webpack_public_path__ + "cf735c23f77ecd51ae9f8028f201cf02.svg";